const requiredFields = [
  "card_holder_name",
  "card_number",
  "expiration_date",
  "security_code",
];

export default requiredFields;
